// extracted by mini-css-extract-plugin
export default {"modal":"Feedback_modal__PRKQi","container":"Feedback_container__UtIbX","close":"Feedback_close__PqrgY","title":"Feedback_title__Y2+k8","submit":"Feedback_submit__P8K4L"};